import React, { createContext } from 'react';

const CollaborateContext = createContext();

export default CollaborateContext;